import { defineMessages } from 'react-intl';

export const IN_NETWORK_INSURANCE_KEY = '@@profile/in_network_insurance';

export const LOCALIZED_STRINGS = defineMessages({
    ViewMore: {
        id: 'Profile.Components.InNetworkInsurance.ViewMore',
        defaultMessage: 'view more',
    },
    ViewLess: {
        id: 'Profile.Components.InNetworkInsurance.ViewLess',
        defaultMessage: 'view less',
    },
    DoctorAccepts: {
        id: 'Profile.Components.InNetworkInsurance.DoctorAccepts',
        defaultMessage: 'This doctor is in-network',
    },
    DoctorDoesNotAccept: {
        id: 'Profile.Components.InNetworkInsurance.DoctorDoesNotAccept',
        defaultMessage: 'This doctor is not in-network',
    },
    ShowInNetworkDoctors: {
        id: 'Profile.Components.InNetworkInsurance.ShowInNetworkDoctors',
        defaultMessage: 'Show doctors who accept your insurance',
    },
    InsuranceCarrierAndPlan: {
        id: 'Profile.Components.InNetworkInsurance.InsuranceCarrierAndPlan',
        defaultMessage: 'Enter your insurance carrier and plan',
    },
});
